import { useDispatch } from 'react-redux'
import { Box, makeStyles, Typography } from '@material-ui/core'

import { useSelector } from '@/store'
import { getAllDevices } from '@/utils/plantOperations'
import { saveElectricScheme } from '@/slices/pv/plantCreation'
import clsx from 'clsx'
import Planimetry from '@/components/Planimetry'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%'
  },
  stepDescription: {
    color: theme.palette.text.secondary
  },
  canvasContainer: {
    minHeight: '100% !important',
    height: '100%'
  }
}))

const PlantElectricScheme = ({ className, ...rest }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { electricScheme, addedDataloggers, plantType, assets } = useSelector(state => state.pvPlantCreation)

  const devices = getAllDevices({ dataloggers: addedDataloggers })

  const saveCanvas = (exportedCanvas) => {
    dispatch(saveElectricScheme(exportedCanvas))
  }

  return (
    <>
      <Box className={clsx(classes.root, className)} {...rest} my={3}>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography component='div' className={classes.stepDescription} variant='body2'>
            Disegna lo schema elettirco dell&apos; impianto
          </Typography>
        </Box>
      </Box>
      <Box height='60vh'>
        <Box position='relative' width='100%' height='100%'>
          <Planimetry
            plantType={plantType}
            assets={assets}
            className={classes.canvasContainer}
            devices={devices}
            importedCanvas={electricScheme}
            saveCanvas={saveCanvas}
          />
        </Box>
      </Box>
    </>
  )
}

export default PlantElectricScheme
